export class AccessToken {
    token_type: string | undefined;
    expires_in: number | undefined;
    ext_expires_in: number | undefined;
    access_token: string | undefined;
}
